import { CohortTranslation } from './CohortTranslation';
import { useCohortDefinitionDSLToUISection } from './useCohortDefinitionDSLToUISection';

export const CohortDefinitionDSLToUISection = () => {
  const { title, emptyStateMainMessage, emptyStateSubMessage, content } =
    useCohortDefinitionDSLToUISection();

  return (
    <CohortTranslation
      title={title}
      emptyStateMainMessage={emptyStateMainMessage}
      emptyStateSubMessage={emptyStateSubMessage}
      content={content}
    />
  );
};
